import React from 'react';
import { Loader2 } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';

const PageLoader = () => {
  const { t } = useLanguage();

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] gap-3">
      <Loader2 size={32} className="animate-spin text-violet-600" />
      <span className="text-sm font-semibold text-[var(--color-muted)]">
        {t('common_loading', 'Loading...')}
      </span>
    </div>
  );
};

export default PageLoader;
